import { configureStore } from "@reduxjs/toolkit";
import appDataReducer from "./data/home/index";
import uiDataReducer from "./data/ui/index";

const store = configureStore({
  reducer: {
    appData: appDataReducer,
    uiState: uiDataReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export default store;
